import styled from "styled-components/macro";
import { borderRadius } from "shared/styles/constants";

export const StyledFlag = styled.span`
  display: inline-flex;

  overflow: hidden;
  border-radius: ${borderRadius.xs};
`;
